module.exports = __webpack_public_path__ + "img/sbs_transit.4e821242.png";